export default __webpack_public_path__ + "static/media/others-job.0a2478aa.svg";